module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gc-Hc-Ia.1005b523.png";